import "core-js/modules/es6.number.constructor";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    // 表格配置项
    options: {
      type: Object,
      default: function _default() {
        return {
          isPagination: true
        };
      }
    },
    // 表格数据来源
    data: {
      type: Array,
      require: false,
      default: function _default() {
        return [];
      }
    },
    // 分页配置
    searchData: {
      type: Object,
      require: false,
      default: function _default() {
        return {};
      }
    },
    pagination: {
      type: Object,
      default: function _default() {
        return {
          currentPage: 1,
          pageSize: 15,
          total: 50
        };
      }
    }
  },
  data: function data() {
    return {
      style: {
        width: '100%'
      },
      selectOrClick: {
        selectDataArray: [],
        clickDataArray: []
      },
      filteres: [],
      visible: false,
      popover: false
    };
  },
  watch: {
    searchData: {
      deep: true,
      immediate: true,
      handler: function handler(newV, old) {
        console.log(newV);
        this.$emit('update:searchData', newV);
      }
    }
  },
  activated: function activated() {
    var _this = this;
    // 解决缓存出现的表格错位问题
    this.$nextTick(function () {
      _this.$refs.myCommontable.doLayout();
    });
  },
  created: function created() {
    var _this2 = this;
    // 设置表格默认属性

    if (!Object.prototype.hasOwnProperty.call(this.options, 'highlightCurrentRow')) {
      this.$set(this.options, 'highlightCurrentRow', true);
    }
    if (!Object.prototype.hasOwnProperty.call(this.options, 'isPagination')) {
      this.$set(this.options, 'isPagination', true);
    }
    if (this.options.tableConfig) {
      if (!Object.prototype.hasOwnProperty.call(this.options.tableConfig, 'border')) {
        this.$set(this.options, 'tableConfig', _objectSpread(_objectSpread({}, this.options.tableConfig), {}, {
          border: true
        }));
      }
    } else {
      this.$set(this.options, 'tableConfig', {
        border: true
      });
    }

    // 设置表头默认属性

    this.options.columnConfig.forEach(function (item, index) {
      if (!['left', 'center', 'right'].includes(item.align)) {
        _this2.$set(_this2.options.columnConfig[index], 'align', 'center');
      }
      if (!item.type) {
        _this2.$set(_this2.options.columnConfig[index], 'type', '');
      }
      if (!item.width) {
        _this2.$set(_this2.options.columnConfig[index], 'width', '');
      }
      if (!item.minWidth) {
        _this2.$set(_this2.options.columnConfig[index], 'minWidth', '');
      }
    }); // 表格默认属性
    if (this.options.paginationConfig) {
      if (!Object.prototype.hasOwnProperty.call(this.options.paginationConfig, 'pageSizes')) {
        this.$set(this.options, 'paginationConfig', _objectSpread(_objectSpread({}, this.options.paginationConfig), {}, {
          pageSizes: [15, 30, 45, 60]
        }));
      }
      if (!Object.prototype.hasOwnProperty.call(this.options.paginationConfig, 'layout')) {
        this.$set(this.options, 'paginationConfig', _objectSpread(_objectSpread({}, this.options.paginationConfig), {}, {
          layout: 'total, sizes, prev, pager, next, jumper'
        }));
      }
    } else {
      this.$set(this.options, 'paginationConfig', {
        pageSizes: [15, 30, 45, 60],
        layout: 'total, sizes, prev, pager, next, jumper'
      });
    }
    if (this.isAutoWidth()) {
      this.$set(this.style, 'width', "".concat(this.isAutoWidth(), "px"));
    } else {}
    // 字体自适应单元格宽度
    this.options.columnConfig = this.options.columnConfig.map(function (item) {
      if (item.label.length >= 5) {
        item.width = String(item.label.length * 18);
      }
      return item;
    });
  },
  methods: {
    // 判断是否需要自适应
    isAutoWidth: function isAutoWidth() {
      var flag = true;
      var arr = this.options.columnConfig;
      for (var index = 0; index < arr.length; index++) {
        if (!arr[index].width) {
          flag = false;
          break;
        }
      }
      if (flag) {
        return arr.reduce(function (pre, cur) {
          return pre + Number(cur.width);
        }, 0) + 2;
      } else {
        return flag;
      }
    },
    // 搜索
    search: function search() {
      this.$emit('callback', 'search');
    },
    // 刷新()
    refresh: function refresh() {
      this.$emit('callback', 'refresh');
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      return 'warning-row';
    },
    // 表格点击事件
    rowClick: function rowClick(row, column, event) {
      this.$set(this.selectOrClick.clickDataArray, 0, row);
      console.log(this.selectOrClick, 'row0');
      this.$emit('callback', 'rowClick', row);
    },
    // 表格多选方法
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectOrClick.selectDataArray = val;
      this.$emit('callback', 'handleSelectionChange', val);
    },
    // 链接单元格点击事件
    linkCellClick: function linkCellClick(columnConfig, scope, index) {
      this.$emit('callback', columnConfig.links[index].fnName, scope);
    },
    // 带下划线链接单元格点击事件
    underlinkCellClick: function underlinkCellClick(columnConfig, scope) {
      this.$emit('callback', 'underLinkCellClick', _objectSpread({
        prop: columnConfig.prop
      }, scope));
    },
    // pageSize 改变时会触发
    handleSizeChange: function handleSizeChange(val) {
      this.$emit('callback', 'handleSizeChange', val);
    },
    // 当前页码发生改变时触发
    handleCurrentChange: function handleCurrentChange(val) {
      this.$emit('callback', 'handleCurrentChange', val);
    },
    // 表格头部右侧按钮点击触发事件
    topBtnsClick: function topBtnsClick(args) {
      console.log(this.selectOrClick, 'row2');
      this.$emit('callback', args.fnName, {
        selectOrClick: this.selectOrClick
      });
    }
  }
};